module.exports = __webpack_public_path__ + "img/orange_059.85337b63.png";